import { render, staticRenderFns } from "./DataExport.global.vue?vue&type=template&id=764cf938&lang=pug&"
import script from "./DataExport.global.vue?vue&type=script&lang=ts&"
export * from "./DataExport.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports